module.exports = __webpack_public_path__ + "static/media/cv.c7d43db9.pdf";